import React, { Component } from 'react'
import '../styles/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import '../styles/footer.css'

export default function Footer()  {
    
    return (
      <div className='align-bottom foot'>
        <div className='row'>
       
          <div className='card  col-6 foot'>
              <div className='card-body'>
                 <div className='card-title'>Contact</div>
                  <div className='card-text'>
                   <p>
                   <i class="bi bi-envelope-at"></i>  administration-agrhymet@cilss.int
                  </p>
                  <p>
                  <i class="bi bi-telephone"></i> (227) 20.31.53.16 / 20.31.54.36 
                  </p>
                  <p>
                  <i class="bi bi-geo-alt"></i> Centre Régional AGRHYMET Boulevard de l’Université
                   
                  </p>
              </div>
              </div>
              
          </div>

          <div className='card  col-6 foot'>
              <div className='card-body'>
                 <div className='card-title'>Team</div>
                  <div className='card-text'>
                   <p>
                   <i class="bi bi-person"></i> IT Department
                  </p>
                  <p>
                  <i class="bi bi-person"></i> Met and Hydro Department
                  </p>
                 
              </div>
              </div>
              
          </div>
          
          </div>
      </div>
    )
  }

